<template>
  <el-container v-loading="loading">
    <!--  功能按钮组 start  -->
    <el-header height="42px">
      <el-button-group class="ik-list-menu">
        <!-- 编辑模式  add - 新增模式, edit - 编辑模式, details - 详情模式 -->
        <el-button
          v-if="pageData.mode === 'edit' || pageData.mode === 'details'"
          class="ik-list-menu-btn"
          size="medium"
          @click="infoCreateBtn"
        >新增
        </el-button>
        <el-button
          v-if="pageData.mode === 'details'"
          class="ik-list-menu-btn"
          size="medium"
          @click="infoUpdateBtn"
        >修改
        </el-button>
        <el-button
          v-if="pageData.mode === 'edit' || pageData.mode === 'details'"
          class="ik-list-menu-btn"
          size="medium"
          @click="infoCopyBtn"
        >复制
        </el-button>
        <el-button
          v-if="pageData.mode === 'edit'"
          class="ik-list-menu-btn"
          size="medium"
          @click="infoDetailsBtn"
        >详情
        </el-button>
        <el-button
          v-if="pageData.mode === 'add' || pageData.mode === 'edit'"
          class="ik-list-menu-btn"
          size="medium"
          @click="infoSaveBtn"
        >
          保存
        </el-button>

        <slot name="endButton" />
        <el-button
          class="ik-list-menu-btn"
          size="medium"
          @click="infoCancelBtn"
        >取消
        </el-button>
      </el-button-group>
    </el-header>
    <!--  功能按钮组 end  -->
    <!--  表单区 start  -->
    <el-main>
      <el-form
        id="ik-info-head"
        ref="form"
        :model="pageData.formData.head"
        class="ik-info-head"
        :inline="true"
        label-width="120px"
        :disabled="pageData.mode === 'details'"
      >
        <el-row v-for="row in pageData.formItems" :key="row.rowIndex">
          <el-col v-for="col in row.items" :key="col.id" class="mb-5" :span="col.span">
            <form-select-item
              v-if="col.type==='select'"
              :ref="`input_${col.code}`"
              v-model="pageData.formData.head[col.code]"
              :code="col.code"
              :name="col.name"
              v-bind="col.config"
              key-field="key"
              value-field="value"
              @onFieldChange="onFieldChange"
            />
            <form-group-select-item
              v-else-if="col.type==='group'"
              v-model="pageData.formData.head[col.code]"
              :code="col.code"
              :name="col.name"
              v-bind="col.config"
              :url="col.config.url"
              :data-down="loading"
            />
            <form-date-item
              v-else-if="col.type==='date'"
              v-model="pageData.formData.head[col.code]"
              :code="col.code"
              :name="col.name"
              v-bind="col.config"
              :url="col.config.url"
              @onFieldChange="onFieldChange"
            />
            <form-time-item
              v-else-if="col.type==='time'"
              v-model="pageData.formData.head[col.code]"
              :code="col.code"
              :name="col.name"
              v-bind="col.config"
              :url="col.config.url"
              @onFieldChange="onFieldChange"
            />
            <form-datetime-item
              v-else-if="col.type==='datetime'"
              v-model="pageData.formData.head[col.code]"
              :code="col.code"
              :name="col.name"
              v-bind="col.config"
              :url="col.config.url"
              @onFieldChange="onFieldChange"
            />
            <form-number-item
              v-else-if="col.type==='number'"
              v-model="pageData.formData.head[col.code]"
              :code="col.code"
              :name="col.name"
              v-bind="col.config"
              @onFieldChange="onFieldChange"
            />
            <form-image-item
              v-else-if="col.type==='oss'"
              :ref="`input_${col.code}`"
              v-model="pageData.formData.head[col.code]"
              :code="col.code"
              :name="col.name"
              v-bind="col.config"
              @onFieldChange="onFieldChange"
            />
            <form-video-item
              v-else-if="col.type==='video'"
              :ref="`input_${col.code}`"
              v-model="pageData.formData.head[col.code]"
              :code="col.code"
              :name="col.name"
              v-bind="col.config"
              @onFieldChange="onFieldChange"
            />
            <form-popup-item
              v-else-if="col.type==='popup'"
              :ref="`input_${col.code}`"
              v-model="pageData.formData.head[col.code]"
              :code="col.code"
              :name="col.name"
              v-bind="col.config"
              v-on="col.handleEvent"
            />
            <form-text-item
              v-else
              :ref="`input_${col.code}`"
              v-model="pageData.formData.head[col.code]"
              :code="col.code"
              :name="col.name"
              v-bind="col.config"
              @onFieldChange="onFieldChange"
            />
          </el-col>
        </el-row>
      </el-form>
    </el-main>
    <soltForm>
      <template #endForm>
        <slot name="endForm" />
      </template>
    </soltForm>
    <!--  表单区 end  -->
  </el-container>
</template>
<script>
import { getById, save, update } from '@/api/ik/data/dataApi'
import soltForm from './soltForm.vue'
export default {
  inject: ["pageData"],
  components: { soltForm },

  data() {
    return {
      id: "",
      // 页面loading
      loading: false
    }
  },
  created() {
    this.pageData.mode = this.$route.params.mode || "add"
    this.id = this.$route.query.id || 0
    if (this.id !== 0) {
      this.get(this.id)
    }
  },
  methods: {
    /**
     * 获取数据
     * @param id
     */
    get(id) {
      this.loading = true
      getById(this.pageData.bgPath, id)
        .then(res => {
          this.pageData.formData = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    /**
     * 更新表单
     * @param key
     * @param value
     */
    updateFormData(key, value) {
      this.$set(this.pageData.formData.head, key, value)
    },
    // --- 事件 ---
    /**
     * 信息页创建按钮点击
     */
    infoCreateBtn() {
      this.$router.push({ path: '/business/' + this.pageData.webPath + '/info/add' })
    },
    /**
     * 信息页编辑按钮点击
     */
    infoUpdateBtn() {
      this.pageData.mode = "edit"
    },
    /**
     * 复制按钮点击事件
     */
    infoCopyBtn() {
      // 修改id为控制
      this.pageData.formData.head.id = 0
      // 修改为编辑模式
      this.pageData.mode = "edit"
    },
    /**
     * 详情按钮被点击
     */
    infoDetailsBtn() {
      // 修改为编辑模式
      this.pageData.mode = "details"
      this.get(this.pageData.formData.head.id)
    },
    /**
     * 保存按钮点击事件
     */
    infoSaveBtn() {
      this.saveOrUpdate()
    },
    /**
     * 取消按钮点击事件
     */
    infoCancelBtn() {
      this.$router.push({ path: '/business/' + this.pageData.webPath + '/list/list' })
    },
    /**
     * 字段变更事件
     * @param fieldName
     * @param oldValue
     * @param newValue
     * @param errorSign
     */
    onFieldChange(fieldName, oldValue, newValue, errorSign) {
      this.$set(this.pageData.formData.head, fieldName, newValue)
      if (this.$refs.form) {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.$emit('onFieldChange', fieldName, oldValue, newValue)
          }
        })
      }
    },
    /**
     * 保存或修改数据
     */
    saveOrUpdate() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const api = this.pageData.formData.head.id === undefined ? save : update
          this.loading = true
          if (this.pageData.useStore) {
            this.pageData.formData.head["storeId"] = this.$store.getters["user/getStoreId"]
            this.pageData.formData.head["storeCode"] = this.$store.getters["user/getStoreCode"]
          }
          api(this.pageData.bgPath, this.pageData.formData).then(res => {
            this.id = res.data
            this.get(res.data)
            this.$message.success("数据已保存")
          })
            .finally(() => {
              this.loading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/styles/listinfo";

.data-directory-tabs-info {
  height: calc(100% - 60px);
}
.el-main{
  max-height: calc(100vh - 82px - 90px);
  height: 100%;
}
.data-directory-tabs-info .el-tabs__content {
  height: calc(100% - 53px);
  overflow: auto;
  min-height: 350px;
}
</style>
